export const STATUS_SURVEY = {
  EXPIRED: 'expired',
  COMPLETED: 'completed',
  UPCOMING: 'upcoming',
};

export const SURVEY_TYPES = {
  PROGRAM: 'program',
  PRE_VISIT: 'pre_visit',
  PROVIDER_POST_VISIT: 'provider_post_visit',
  APPOINTMENT_SATISFACTION: 'appointment_satisfaction',
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitSurveyListView/constants.js